import React, { useCallback } from 'react';
import Icon from '@/components/ui/AppIcon';

export interface FileItem {
  name: string;
  size: number;
  pageCount: number;
}

export interface FileCardProps {
  file: FileItem;
  onRemove: () => void;
  className?: string;
  theme?: {
    primary?: string;
    primaryLight?: string;
    primaryBorder?: string;
    primaryShadow?: string;
  };
}

export const FileCard: React.FC<FileCardProps> = ({ file, onRemove, className = '', theme }) => {
  const btnTheme = {
    primary: theme?.primary || '#EF4444',
    primaryLight: theme?.primaryLight || '#FEF2F2',
    primaryBorder: theme?.primaryBorder || '#FECACA',
    primaryShadow: theme?.primaryShadow || 'rgba(239, 68, 68, 0.28)',
  };

  const formatSize = useCallback((bytes: number) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }, []);

  return (
    <div
      className={`flex items-center justify-between mb-6 bg-brand-surface p-4 rounded-3xl border border-brand-border ${className}`}
    >
      <div className="min-w-0">
        <h2
          title={file.name}
          className="text-lg font-bold text-brand-dark font-heading mb-0.5 truncate"
        >
          {file.name}
        </h2>

        <div className="flex items-center gap-3 text-xs font-body">
          <span className="flex items-center gap-1.5 px-2 py-0.5 rounded-md bg-white border border-brand-border">
            <Icon name="DocumentIcon" size={12} />
            {file.pageCount} pages
          </span>

          <span>{formatSize(file.size)}</span>
        </div>
      </div>

      <button
        onClick={onRemove}
        className="w-10 h-10 flex items-center justify-center rounded-xl border transition-colors"
        style={{
          background: btnTheme.primaryLight,
          borderColor: btnTheme.primaryBorder,
          color: btnTheme.primary,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = btnTheme.primary;
          e.currentTarget.style.color = 'white';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = btnTheme.primaryLight;
          e.currentTarget.style.color = btnTheme.primary;
        }}
      >
        <Icon name="XMarkIcon" size={20} />
      </button>
    </div>
  );
};
